import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'
import pclnExpt from '@pcln/experimentation'
import { PackageListingPriceChangeBanner } from '@pcln/horizon-package-components'
import React, { useEffect } from 'react'
import { isPackagePriceChangeBannerEligible } from './helpers'

export function PackagePriceChangeBanner({
  isPackageListings = false,
  bundleComponents = [],
  displayListings = false,
  showLoadingOverlay = false,
  listings = [],
  recommendedListings = [],
  activeTabId,
  hasPriorPackageSelection = false,
}) {
  const isEligible = isPackagePriceChangeBannerEligible({
    isPackageListings,
    bundleComponents,
    displayListings,
    showLoadingOverlay,
    listings,
    recommendedListings,
    activeTabId,
    hasPriorPackageSelection,
  })
  const isVariant = pclnExpt.getTestState('PKG_PRICE_CHANGE_BANNER_FLY_LISTINGS') === 'VARIANT'
  const shouldShow = isEligible && isVariant

  useEffect(() => {
    if (isEligible) {
      pclnExpt.fireImpression('PKG_PRICE_CHANGE_BANNER_FLY_LISTINGS')
    }
  }, [isEligible])

  useEffect(() => {
    if (shouldShow) {
      logEvent('display', {
        type: 'FLY_pkg_price_change_banner',
        page_name: 'listings',
        product_name: 'bundle',
      })
    }
  }, [shouldShow])

  if (!shouldShow) return null

  return (
    <div
      className='mx-2 mb-2 lg:mx-0'
      data-testid='notification-banner'
      data-autobot-element-id='PKG_PRICE_CHANGE_BANNER'
    >
      <PackageListingPriceChangeBanner />
    </div>
  )
}
